var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoPp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3253 13.9996C15.9769 13.9996 18.9364 11.0401 18.9364 7.38845C18.9364 3.73685 15.9769 0.777344 12.3253 0.777344C8.6737 0.777344 5.71419 3.73685 5.71419 7.38845C5.71419 11.0401 8.6737 13.9996 12.3253 13.9996ZM16.9531 15.6523H16.0905C14.9439 16.1792 13.6682 16.4787 12.3253 16.4787C10.9824 16.4787 9.71185 16.1792 8.56007 15.6523H7.69753C3.86515 15.6523 0.755859 18.7616 0.755859 22.594V24.7426C0.755859 26.1113 1.86632 27.2218 3.23503 27.2218H21.4156C22.7843 27.2218 23.8948 26.1113 23.8948 24.7426V22.594C23.8948 18.7616 20.7855 15.6523 16.9531 15.6523ZM33.6358 9.02057L32.2 7.56923C31.9624 7.32648 31.575 7.32648 31.3323 7.56406L25.9194 12.9356L23.5694 10.5701C23.3318 10.3273 22.9444 10.3273 22.7017 10.5649L21.2503 12.0059C21.0076 12.2435 21.0076 12.6309 21.2451 12.8736L25.4649 17.1243C25.7025 17.3671 26.0898 17.3671 26.3326 17.1295L33.6306 9.88828C33.8682 9.64553 33.8734 9.25816 33.6358 9.02057Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoPp);
export default __webpack_public_path__ + "static/media/AutoPP.9550261b3f3da1e364def06f04d40a54.svg";
export { ForwardRef as ReactComponent };